import {
	PUBLIC_OPENID_ISSUER_URL,
	PUBLIC_VIVENU_FRONTEND_URL,
	PUBLIC_VIVENU_SELLER_ID,
	PUBLIC_VIVENU_DONETSK_FRONTEND_URL,
	PUBLIC_VIVENU_DONETSK_SELLER_ID
} from '$env/static/public';
import { buildVivenuLoginUrl } from '$lib/links';
import type { VivenuExchangeToken } from '$lib/vivenu/types';

export function getAccountNavNodes(exchangeToken?: VivenuExchangeToken) {
	const transactionsUrl = buildVivenuLoginUrl(
		`${PUBLIC_VIVENU_FRONTEND_URL}/seller/${PUBLIC_VIVENU_SELLER_ID}/account/transactions`,
		exchangeToken?.exchangeToken
	);
	const ticketsUrl = buildVivenuLoginUrl(
		`${PUBLIC_VIVENU_FRONTEND_URL}/seller/${PUBLIC_VIVENU_SELLER_ID}/account/tickets`,
		exchangeToken?.exchangeToken
	);
	const seasonTicketUrl = buildVivenuLoginUrl(
		`${PUBLIC_VIVENU_FRONTEND_URL}/account/subscriptions`,
		exchangeToken?.exchangeToken
	);

	// https://shakhtar-ticketshop-stage.schalke04.de/seller/666aba3d66884fe933213e31/account/tickets
	const donetskTicketsUrl = buildVivenuLoginUrl(
		`${PUBLIC_VIVENU_DONETSK_FRONTEND_URL}/seller/${PUBLIC_VIVENU_DONETSK_SELLER_ID}/account/tickets`,
		exchangeToken?.exchangeToken
	);

	return [
		{
			url: '/account',
			translations: [
				{ languages_code: 'de-DE', title: 'Mein Konto' },
				{ languages_code: 'en-US', title: 'My Account' }
			],
			highlighted: true,
			children: [
				{
					url: `${PUBLIC_OPENID_ISSUER_URL}/s/profile/home`,
					translations: [
						{ languages_code: 'de-DE', title: 'Mein Profil' },
						{ languages_code: 'en-US', title: 'My Profile' }
					],
					children: [
						{
							url: `${PUBLIC_OPENID_ISSUER_URL}/s/profile/home`,
							translations: [
								{ languages_code: 'de-DE', title: 'Mein Profil' },
								{ languages_code: 'en-US', title: 'My Profile' }
							]
						}
					]
				},
				{
					url: transactionsUrl,
					translations: [
						{ languages_code: 'de-DE', title: 'Bestellungen' },
						{ languages_code: 'en-US', title: 'Orders' }
					],
					children: [
						// {
						// 	url: seasonTicketUrl,
						// 	translations: [
						// 		{ languages_code: 'de-DE', title: 'Dauerkarten' },
						// 		{ languages_code: 'en-US', title: 'Season Tickets' }
						// 	]
						// },
						{
							url: transactionsUrl,
							translations: [
								{ languages_code: 'de-DE', title: 'Bestellhistorie' },
								{ languages_code: 'en-US', title: 'My Orders' }
							]
						},
						{
							url: ticketsUrl,
							translations: [
								{ languages_code: 'de-DE', title: 'Tickethistorie' },
								{ languages_code: 'en-US', title: 'My Tickets' }
							]
						},
						{
							url: donetskTicketsUrl,
							translations: [
								{ languages_code: 'de-DE', title: 'Tickets Shakhtar Donetsk' },
								{ languages_code: 'en-US', title: 'Tickets Shakhtar Donetsk' }
							]
						}
					]
				},
				{
					url: '/auswaerts/auswaertskarten',
					translations: [
						{ languages_code: 'de-DE', title: 'Auswärtsanfragen' },
						{ languages_code: 'en-US', title: 'Away Requests' }
					],
					children: [
						{
							url: '/auswaerts/konto',
							translations: [
								{ languages_code: 'de-DE', title: 'Anfragehistorie & Punktekontingent' },
								{ languages_code: 'en-US', title: 'My Requests & Point Quote' }
							]
						}
					]
				}
			]
		}
	];
}
